/**
 * Calcula la edad a partir de una fecha de nacimiento
 * @param fechaNacimiento - Fecha de nacimiento en formato ISO (YYYY-MM-DD) o Date
 * @returns Edad en años
 */
export const calcularEdad = (fechaNacimiento: string | Date): number => {
  const fecha = typeof fechaNacimiento === 'string' 
    ? new Date(fechaNacimiento) 
    : fechaNacimiento;
  
  const hoy = new Date();
  let edad = hoy.getFullYear() - fecha.getFullYear();
  const mes = hoy.getMonth() - fecha.getMonth();
  
  // Si aún no ha cumplido años este año, restar 1
  if (mes < 0 || (mes === 0 && hoy.getDate() < fecha.getDate())) {
    edad--;
  }
  
  return edad;
};

/**
 * Determina si una persona es menor de edad (< 18 años)
 * @param fechaNacimiento - Fecha de nacimiento en formato ISO (YYYY-MM-DD) o Date
 * @returns true si es menor de edad
 */
export const esMenorDeEdad = (fechaNacimiento: string | Date): boolean => {
  return calcularEdad(fechaNacimiento) < 18;
};

/**
 * Valida que una fecha de nacimiento sea válida
 * @param fechaNacimiento - Fecha de nacimiento en formato ISO (YYYY-MM-DD)
 * @returns true si la fecha es válida
 */
export const validarFechaNacimiento = (fechaNacimiento: string): boolean => {
  const fecha = new Date(fechaNacimiento);
  const hoy = new Date();
  const anioMinimo = new Date('1900-01-01');
  
  // No debe ser una fecha futura
  if (fecha > hoy) return false;
  
  // No debe ser antes de 1900
  if (fecha < anioMinimo) return false;
  
  return true;
};

/**
 * Formatea una fecha para mostrar en formato legible
 * @param fecha - Fecha en formato ISO o Date
 * @returns Fecha formateada como "DD/MM/YYYY"
 */
export const formatearFecha = (fecha: string | Date): string => {
  const fechaObj = typeof fecha === 'string' ? new Date(fecha) : fecha;
  const dia = fechaObj.getDate().toString().padStart(2, '0');
  const mes = (fechaObj.getMonth() + 1).toString().padStart(2, '0');
  const anio = fechaObj.getFullYear();
  return `${dia}/${mes}/${anio}`;
};
